import { connect } from "react-redux";
import _ from 'lodash';
import moment from 'moment';
import React, { Component, Fragment } from 'react';
import ViewHeader from '../view-header';
import ReactTooltip from 'react-tooltip';
import { getCases, changeCaseStatus, getCase } from "./actions";
import { processImageUpdate } from "../AdminCaseDetails/helpers";
import {
    addBooking,
    addPatient,
    addDentist,
    getAllPatientsRequest,
    getData,
    getParentCases
    , getVacationDaysRequest} from "../dashboard/actions";
import ModalComponent from '../../../../components/Modal';
import Notice from "../../../../components/Notification/newNotification";
import './Allcases.scss'
import { globals } from '../../../../../../common/constants';

//Icons
import IconSpinner from 'react-icons/lib/fa/spinner';
import History from "../../../../components/History";
import SubcaseModalBody from "../../../../components/CreateSubcase";
import {cancelCase, convertCase} from "../AdminCaseDetails/actions";
import Table from "../../../../components/Table";
import {scrollTo} from "../../../../helpers";
import {getAvailableUnitsList} from '../AvailableUnits/actions';
import './Allcases.scss'
import {
    APPROVE_CASE_SUCCESS_MESSAGE,
    CONVERT_TO_CASE_SUCCESS_MESSAGE,
    CONVERT_TO_SUBCASE_SUCCESS_MESSAGE,
    DELETE_CASE_ERROR_MESSAGE,
    DELETE_CASE_SUCCESS_MESSAGE,
    REJECT_CASE_SUCCESS_MESSAGE,
    UPDATE_CASE_SUCCESS_MESSAGE
} from "../../../../shared/constants";
import {
    startImageUploading
} from "../../../../shared/redux/actions"
import SubcaseForm from "../../../../components/SubCaseForm";
import AddBookingForm from "../../../../components/Home/addBookingForm";

class allCases extends Component {
    constructor(props) {
        super(props);
        this.bridgesRef = React.createRef();
        this.state = {
            dataProcessing: false,
            showToaster: true,
            changeStatusModal: false,
            caseId: 0,
            caseStatus: '',
            modalHeaderText: '',
            modalBodyText: '',
            modalHeaderType: '',
            isHistoryModalOpen: false,
            changeDateModal: false,
            parentId: null,
            isOpenConvertModal: false,
            isOpenProceedModal: false,
            notesByLabAdminModal:false,
            adminNote:'',
            currentPage: 1,
            filterOptions: this.props.history &&  this.props.history.location &&  this.props.history.location.state && this.props.history.location.state.filterData ? this.props.history.location.state.filterData : {},
            sortingOptions: {},
            changeHoldStatusId: '',
            prevHoldStatus: '',
            dropRowId: null,
            isOpenCasesDropdown:false,
            createSubcaseModal: false,
            isOpenSubcaseForm: false,
            startDate: moment().add(10, 'days'),
            defaultDate: new Date(),
            startOfCalendarView: moment().startOf('month').startOf('week').format('YYYY-MM-DD'),
            endOfCalendarView: moment().endOf('month').endOf('week').format('YYYY-MM-DD'),
            validationBooking: {
                dentistNotExists: false,
                dentist_id: false,
                patient_id: false,
                sending_date: false,
                number_of_units: false,
                type: false,
                implant: false,
                enclosedBox: false,
                dentist_name: false,
                dentistSelected: false,
                patient_name: false
            },
            checkedTeeth:[],
            addingBookingInfo: {
                bridges:[],
                parent_id: null,
                patient_id: 0,
                sending_date: null,
                number_of_units: 0,
                type: '',
                notes: '',
                admin_case_notes: '',
                color: '',
                signature: '',
                license: '',
                implant: '',
                implantType: '',
                implantSize: '',
                enclosedBox: [],
                implantParts: {},
                image: [],
            },
            implantsPartObject: {
                1: { name: 'Impression coping ', number: 0 },
                2: { name: 'Impression screw ', number: 0 },
                3: { name: 'Lab analog ', number: 0 },
                4: { name: 'Prosthetic screw ', number: 0 },
                5: { name: 'Abutment/Ti', number: 0 },
                6: { name: 'Other ', number: 0 }
            },
            enclosedBoxObject: {
                1: { name: 'Impression/master model' },
                2: { name: 'Antagonist model/impression' },
                3: { name: 'Bite' },
                4: { name: 'Pre-op/temp model/impression' },
                5: {name:  'Optical scan'},
                6: { name: 'Implant parts' },
                7: { name: 'Other ' }
            },
            tableColumns: [
                {
                    name: '$$',
                    key: 'filter',
                    render: (cell, row) => this.childColumnFormatter(cell, row),
                    src: require('../../../../images/filter.svg')
                },
                {
                    name: 'Case ID',
                    key: 'id',
                    placeholder: "1234",
                    render: (cell, row) => this.idFormatter(cell, row),
                    isSortable: true,
                    isFilterable: true,
                    filterType: 'number'
                },
                {
                    name: 'Submission Date',
                    key: 'dateOfSubmission',
                    placeholder: "DD/MM/YYYY",
                    render: cell => this.dateFormatter(cell),
                    isSortable: true,
                    isFilterable: true,
                    filterType: 'date'
                },
                {
                    name: 'Sending Date',
                    key: 'sendingDate',
                    placeholder: "DD/MM/YYYY",
                    render: cell => this.dateFormatter(cell),
                    isSortable: true,
                    isFilterable: true,
                    filterType: 'date'
                },
                {
                    name: 'Return Date',
                    key: 'dateOfReturn',
                    placeholder: "DD/MM/YYYY",
                    render: cell => this.dateFormatter(cell),
                    isSortable: true,
                    isFilterable: true,
                    filterType: 'date'
                },
                {
                    name: 'Dentist',
                    key: 'dentist',
                    render: cell => this.dentistFormatter(cell),
                    isSortable: true,
                    isFilterable: true,
                    filterType: 'text'
                },
                {
                    name: 'Units',
                    key: 'numberOfUnits',
                    render: cell => cell,
                    isSortable: true,
                    isFilterable: true,
                    filterType: 'number'
                },
                {
                    name: 'Patient',
                    key: 'patient',
                    render: cell => this.patientFormatter(cell),
                    isSortable: true,
                    isFilterable: true,
                    filterType: 'text'
                },
                {
                    name: 'Type',
                    key: 'type',
                    render: cell => this.typeFormatter(cell),
                    isSortable: true,
                    isFilterable: true,
                    filterType: 'select',
                    options: [
                        {value: 'Prototype', label: 'Prototype'},
                        {value: 'Zirconia', label: 'Zirconia'},
                        {value: 'Ceramic', label: 'Ceramic'},
                        {value: 'Temp', label: 'Temp'},
                        {value: 'Other', label: 'Other'}
                    ]
                },
                {
                    name: 'Status',
                    key: 'status',
                    render: arg => arg === 'Onhold' ? 'On hold' : arg,
                    isSortable: true,
                    isFilterable: true,
                    filterType: 'select',
                    options: [{value: 'Pending', label: 'Pending'}, {
                        value: 'Overdue',
                        label: 'Overdue'
                    }, {value: 'Scheduled', label: 'Scheduled'}, {
                        value: 'Received',
                        label: 'Received'
                    }, {value: 'Ready', label: 'Ready'}, {value: 'Rejected', label: 'Rejected'}, {
                        value: 'Archived',
                        label: 'Archived'
                    }, {value: 'Onhold', label: 'On hold'}
                    ]
                },
                {name: 'Photos', key: 'numberOfImages', render: (cell, row) => this.imagesFormatter(cell, row)},
                {
                    name: 'Created By',
                    key: 'createdBy',
                    render: arg => arg,
                    isSortable: true,
                    customClassName: 'createdBy__th',
                    isFilterable: true,
                    filterType: 'select',
                    options: [{value: 'Dentist', label: 'Dentist'}, {value: 'Lab Admin', label: 'Lab Admin'}]
                },
                {name: 'History', key: 'history', render: (cell, row) => this.historyFormatter(cell, row)},
                {name: 'Actions', key: 'actions', render: (cell, row) => this.ActionFormatter(cell, row)},
            ],
            selectedCaseToShowHistory: null,
        };
        this.ActionFormatter = this.ActionFormatter.bind(this);
        this.childColumnFormatter = this.childColumnFormatter.bind(this);
        this.typeFormatter = this.typeFormatter.bind(this);
        this.imagesFormatter = this.imagesFormatter.bind(this);
        this.historyFormatter = this.historyFormatter.bind(this);
        this.idFormatter = this.idFormatter.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
        this.handleFilterDataChange = this.handleFilterDataChange.bind(this);
        this.getFilteredDataRequest = this.getFilteredDataRequest.bind(this);
        this.handleSort = this.handleSort.bind(this);
        this.patientFormatter = this.patientFormatter.bind(this);
        this.dentistFormatter = this.dentistFormatter.bind(this);
        this.adminNotesIconFormatter = this.adminNotesIconFormatter.bind(this);
        this.handleChangeDentist = this.handleChangeDentist.bind(this);
    }


    componentDidMount() {
        if(this.props.history && this.props.history.location && this.props.history.location.state){
            if (this.props.history.location.state.filterData) {
                this.setState({filterOptions:this.props.history.location.state.filterData})
            }
            if (this.props.history.location.state.pageNumber) {
                this.setState({ currentPage: this.props.history.location.state.pageNumber});
            }
        }
        this.props.getVacationDays();
        this.props.getAllPatients();
        this.props.getData(this.state.startOfCalendarView, this.state.endOfCalendarView);
        const navBig = document.body.clientWidth > globals.NAV_MIDDLE;
        if(!navBig){
            this.setState({tableColumns: [
                    {
                        name: '$$',
                        key: 'filter',
                        render: (cell, row) => this.childColumnFormatter(cell, row),
                        src: require('../../../../images/filter.svg')
                    },
                    {
                        name: 'Case ID',
                        key: 'id',
                        render: (cell, row) => this.idFormatter(cell, row),
                        isSortable: true,
                        isFilterable: true,
                        filterType: 'number'
                    },
                    {
                        name: 'Dentist',
                        key: 'dentist',
                        render: cell => this.dentistFormatter(cell),
                        isSortable: true,
                        isFilterable: true,
                        filterType: 'text'
                    },
                    {
                        name: 'Status',
                        key: 'status',
                        render: arg => arg === 'Onhold' ? 'On hold' : arg,
                        isSortable: true,
                        isFilterable: true,
                        filterType: 'select',
                        options: [{value: 'Pending', label: 'Pending'}, {
                            value: 'Overdue',
                            label: 'Overdue'
                        }, {value: 'Scheduled', label: 'Scheduled'}, {
                            value: 'Received',
                            label: 'Received'
                        }, {value: 'Ready', label: 'Ready'}, {value: 'Rejected', label: 'Rejected'}, {
                            value: 'Archived',
                            label: 'Archived'
                        }, {value: 'Onhold', label: 'On hold'}
                        ]
                    },
                    {name: '', key: 'actions', render: (cell, row) => this.dropRowFormatter(cell, row)},
                ],
                dropDownColumns: [
                    {
                        name: 'Submission Date',
                        key: 'dateOfSubmission',
                        render: cell => this.dateFormatter(cell),
                        isSortable: true,
                        placeholder: "DD/MM/YYYY",
                        isFilterable: true,
                        filterType: 'date'
                    },
                    {
                        name: 'Sending Date',
                        key: 'sendingDate',
                        placeholder: "DD/MM/YYYY",
                        render: cell => this.dateFormatter(cell),
                        isSortable: true,
                        isFilterable: true,
                        filterType: 'date'
                    },
                    {
                        name: 'Return Date',
                        key: 'dateOfReturn',
                        placeholder: "DD/MM/YYYY",
                        render: cell => this.dateFormatter(cell),
                        isSortable: true,
                        isFilterable: true,
                        filterType: 'date'
                    },
                    {
                        name: 'Patient',
                        key: 'patient',
                        render: cell => this.patientFormatter(cell),
                        isSortable: true,
                        isFilterable: true,
                        filterType: 'text'
                    },
                    {
                        name: 'Units',
                        key: 'numberOfUnits',
                        render: cell => cell,
                        isSortable: true,
                        isFilterable: true,
                        filterType: 'number'
                    },
                    {
                        name: 'Type',
                        key: 'type',
                        render: cell => this.typeFormatter(cell),
                        isSortable: true,
                        isFilterable: true,
                        filterType: 'select',
                        options: [
                            {value: 'Prototype', label: 'Prototype'},
                            {value: 'Zirconia', label: 'Zirconia'},
                            {value: 'Ceramic', label: 'Ceramic'},
                            {value: 'Temp', label: 'Temp'},
                            {value: 'Other', label: 'Other'}
                        ]
                    },
                    {name: 'Photos', key: 'numberOfImages', render: (cell, row) => this.imagesFormatter(cell, row)},
                    {
                        name: 'Created By',
                        key: 'createdBy',
                        render: arg => arg,
                        isSortable: true,
                        customClassName: 'createdBy__th',
                        isFilterable: true,
                        filterType: 'select',
                        options: [{value: 'Dentist', label: 'Dentist'}, {value: 'Lab Admin', label: 'Lab Admin'}]
                    },
                    {
                        name: 'Status',
                        key: 'status',
                        render: arg => arg === 'Onhold' ? 'On hold' : arg,
                        isSortable: true,
                        isFilterable: true,
                        filterType: 'select',
                        options: [{value: 'Pending', label: 'Pending'}, {
                            value: 'Overdue',
                            label: 'Overdue'
                        }, {value: 'Scheduled', label: 'Scheduled'}, {
                            value: 'Received',
                            label: 'Received'
                        }, {value: 'Ready', label: 'Ready'}, {value: 'Rejected', label: 'Rejected'}, {
                            value: 'Archived',
                            label: 'Archived'
                        }, {value: 'Onhold', label: 'On hold'}
                        ]
                    },
                    {name: 'History', key: 'history', render: (cell, row) => this.historyFormatter(cell, row)},
                    {name: 'Actions', key: 'actions', render: (cell, row) => this.ActionFormatter(cell, row)},
                ]
            })
        }
        document.title = "Cases";
        this.props.getCases(this.state.currentPage, this.state.filterOptions, this.state.sortingOptions);
        this.props.getParentCases();
        this.interval = setInterval(() => this.props.getCases(this.state.currentPage, this.state.filterOptions, this.state.sortingOptions), 7000);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    handlePageChange(currentPage) {
        scrollTo(0, 'smooth')
        this.setState({currentPage});
        this.props.getCases(currentPage, this.state.filterOptions, this.state.sortingOptions);
    }

    getDentistName(patientId) {
        const dentist = this.dentistList.find(dentist => {
            const patient = dentist.patients.find(item => {
                return patientId === item.id
            })
            return patient && patient.dentist_id === dentist.id;

        })
        if (dentist) {
            return dentist.first_name + ' ' + dentist.last_name
        }
    }

    handleChangeBookingInfo(key, value, find) {
        this.setState(prevState => ({
            validationBooking: {
                ...prevState.validationBooking,
                [key]:  !value,
            }
        }));
        if (key === 'enclosedBox') {
            const enclosedBox = this.state.addingBookingInfo[key];
            const find = enclosedBox.find(item => {
                return item === value
            });
            const updateData = (find > 0) ? enclosedBox.filter(e => e !== value) : [...this.state.addingBookingInfo[key], value];

            this.setState({
                addingBookingInfo: {...this.state.addingBookingInfo, [key]: updateData}
            })
        } else if (key === 'implantParts') {
            let updateData, implantParts = this.state.addingBookingInfo[key];
            if (implantParts[value] !== undefined && !find) {
                delete implantParts[value]
                updateData = implantParts;
            } else {
                updateData = {...this.state.addingBookingInfo[key], [(find) ? find : value]: (find) ? value : 0}
            }
            this.setState({
                addingBookingInfo: {...this.state.addingBookingInfo, [key]: updateData}
            })
        } else if (key === 'image') {
            const images = this.state.addingBookingInfo.image;
            if (value.hasError) {
                this.setState({hasErrorImages: true});
            } else {
                this.setState({
                    addingBookingInfo: {...this.state.addingBookingInfo, image: [...images, ...value.currentImage]},
                    hasErrorImages: false
                })
            }
        } else if (key === 'admin_case_notes') {
            this.setState({
                ...this.state,
                addingBookingInfo: {
                    ...this.state.addingBookingInfo,
                    [key]: value
                }
            })
        } else {
            const dentistName = (key === 'patient_id') ? this.getDentistName(parseInt(value, 10)) : this.state.dentistName;
            this.setState({
                dentistName: dentistName,
                addingBookingInfo: {
                    ...this.state.addingBookingInfo,
                    [key]: value
                }
            })
        }
    }

    linkToCasePage(row, e) {
        if (!row.parentId) {
            e.stopPropagation();
        }
        const {currentPage, filterOptions,sortingOptions} = this.state;
        this.props.history.push({
            pathname: '/sm-admin/case-details/' + row.id,
            state: {page: '/sm-admin/cases', pageName: 'Cases',sortingOptions: sortingOptions, filterData: filterOptions, pageNumber: currentPage}
        });
    }

    handleClose = () => {
        if (this.state.isOpenProceedModal) {
            this.setState({isOpenConvertModal: true, isOpenProceedModal: false});
        } else {
            this.setState({
                changeStatusModal: false, isHistoryModalOpen: false, selectedCaseToShowHistory: null, isOpenConvertModal: false, changeDateModal: false,notesByLabAdminModal:false,
            });
        }
    }


    get patientList() {
        return this.props.adminDashboard.allPatientsList;
    }

    openDropRowId = (cell) => {
        if(cell === this.state.dropRowId){
            this.setState({dropRowId:null})
        } else {
            this.setState({dropRowId:cell})
        }
    }

    dropRowFormatter(cell,row) {
        return <div onClick={()=>this.openDropRowId(row.id)}>
            <span className="kr kr-arrow" />
            {<div></div>}
        </div>
    }

    dateFormatter(cell) {
        return moment(cell).format('DD/MM/YYYY');
    }

    historyFormatter(cell, row) {
        if (row.status !== 'Archived') {
            const tooltip = row.numberOfLogs ? "Click here to view the timeline of changes made to this case." : "No history";
            return (
                <div>
                    <div className="see-history" data-for="history">
                        <button
                            disabled={!row.numberOfLogs}
                            className="btn btn-link"
                            onClick={() => this.setState({ isHistoryModalOpen: true, selectedCaseToShowHistory: row.id })}
                        >
                            <span className="kr kr-history" />
                            <span>See History</span>
                        </button>
                    </div>
                </div>);
        } else {
            return '';
        }
    }

    getHistory(event, caseId) {
        event.stopPropagation();
        this.props.getCaseDetails(caseId);
        this.setState({isHistoryModalOpen: true})
    }

    idFormatter(cell, row) {
        return <div className="info-icons">{cell}
            <div className="info-icons__block">
                {row.createdBy === "Lab Admin" ? <span className="kr kr-by-admin" /> : ''}
                {this.adminNotesIconFormatter(cell, row)}
            </div>
        </div>
    }

    typeFormatter(cell) {
        switch (cell) {
            case 'Prototype': {
                return <div className="prototype-case case-type">{cell}</div>
            }
            case 'Zirconia': {
                return <div className="zirconia-case case-type">{cell}</div>
            }
            case 'Ceramic': {
                return <div className="ceramic-case case-type">{cell}</div>
            }
            case 'Temp': {
                return <div className="temp-case case-type">{cell}</div>
            }
            case 'Other': {
                return <div className="other-case case-type">{cell}</div>
            }
            default: {
                break;
            }
        }

    }

    childColumnFormatter(cell, row) {
        return <Fragment>
            <div className="cases-icons">
                {row.status !== 'Archieved' ? <button className="btn btn-link" data-for="view" data-tip="View Case Details" onClick={(e) => this.linkToCasePage(row, e)}>
                    <span className="kr kr-open" />
                    <ReactTooltip id="view" place="right" type="light" effect="float" />
                </button> : ''}
                {row.parentId && <div className="subcase_image">
                    <a
                        data-tip={`This is a subcase of case N${row.parentId}`}
                        data-for="child"
                        href={`/sm-admin/case-details/${row.parentId}`}
                    >
                        <span className="kr kr-parent" />
                    </a>
                    <ReactTooltip id="child" place="right" type="light" effect="float" />
                </div>}
            </div>
        </Fragment>;
    }

    openLabAdminModal = (id,note) => {
        this.setState({notesByLabAdminModal:true,adminNote:note});
    }

    adminNotesIconFormatter(cell, row) {
        return row.admin_case_notes && <div
            className="subcase_image">
            <div
                onClick={()=>this.openLabAdminModal(row.id,row.admin_case_notes)}
                data-tip={'Notes by Lab Admin'}
                data-for="admin-notes"
            >
                <span className="kr kr-notes" />
            </div>
            <ReactTooltip id="admin-notes" place="right" type="light" effect="float" />
        </div>;
    }

    getReceiveButton = (isReceived = false, cell) => {
        if (isReceived) {
            return (
                <button data-tip="Not Received" className="btn case-action-btn" onClick={(event) => this.onChangeStatus(event, cell.id, 'not_received', false, cell)}>
                    <span className="kr kr-close" />
                </button>
            )
        } else {
            return (
                <button data-tip="Received" className="btn case-action-btn" onClick={(event) => this.onChangeStatus(event, cell.id, 'received')}>
                    <span className="kr kr-check" />
                </button>
            )
        }
    };

    ActionFormatter(row, cell) {
        const dataTip = cell.parentId ? "Convert to Case" : "Convert to Subcase";
        const actionForConvert =
            <button data-tip={dataTip} data-for="convert" className="btn case-action-btn" onClick={(e) => this.convertCase(cell.id, e)}>
                <span className="kr kr-subcase" />
            </button>;
        switch (cell.status) {
            case 'Pending': {
                return (
                    <div>
                        <button data-tip="Approve" className="btn case-action-btn" onClick={(event) => this.onChangeStatus(event, cell.id, 'scheduled', false, cell)}>
                            <span className="kr kr-check" />
                        </button>
                        <button data-tip="Reject" className="btn case-action-btn" onClick={(event) => this.onChangeStatus(event, cell.id, 'rejected')}>
                            <span className="kr kr-close" />
                        </button>
                        {actionForConvert}
                        <ReactTooltip place="top" type="light" effect="float"/>
                        <ReactTooltip place="top" id="convert" type="light" effect="float"/>
                    </div>
                );
            }
            case 'Scheduled': {
                return (
                    <div>
                        <button data-tip="Received" className="btn case-action-btn" onClick={(event) => this.onChangeStatus(event, cell.id, 'received')}>
                            <span className="kr kr-check" />
                        </button>
                        <button data-tip="Delete" className="btn case-action-btn" onClick={(event) => this.onChangeStatus(event, cell.id, 'cancel')}>
                            <span className="kr kr-cancel" />
                        </button>
                        {actionForConvert}
                        <ReactTooltip place="top" id="convert" type="light" effect="float"/>
                        <ReactTooltip place="top" type="light" effect="float"/>
                    </div>
                );
            }
            case 'Onhold': {
                return (
                    <div>
                        {cell.status !== 'Onhold' ?
                            <button data-tip='Remove from On hold' className="btn case-action-btn"
                                    onClick={(event) => this.onChangeStatus(event, cell.id, 'onhold')}>
                                <span className="kr kr-on-hold" />
                            </button> :
                            <button data-tip='Remove from On hold' className="btn case-action-btn"
                                    onClick={(event) => this.onChangeStatus(event, cell.id, cell.prevStatus, true, cell)}>
                                <span className="kr kr-unhold" />
                            </button>}
                        <ReactTooltip place="top" id="convert" type="light"  />
                        <ReactTooltip place="top" type="light"  />
                    </div>
                );
            }
            case 'Ready': {
                return (
                    <div>
                        <button
                            data-tip="Revert status"
                            className="btn case-action-btn"
                            onClick={(event) => this.onChangeStatus(event, cell.id, cell.prevStatus, false, cell)}>
                            <span className="kr kr-unhold" />
                        </button>
                        {actionForConvert}
                        <ReactTooltip place="top" id="convert" type="light" effect="float" />
                        <ReactTooltip place="top" type="light" effect="float" />
                    </div>
                );
            }
            case 'Received': {
                return (
                    <div>
                        {this.getReceiveButton(true, cell)}
                        <button data-tip="Ready" className="btn case-action-btn" onClick={(event) => this.onChangeStatus(event, cell.id, 'ready')}>
                            <span className="kr kr-ready" />
                        </button>
                        <button data-tip="Move to On hold" className="btn case-action-btn"
                                onClick={(event) => this.onChangeStatus(event, cell.id, 'onhold')}>
                            <span className="kr kr-on-hold" />
                        </button>
                        &nbsp;
                        {actionForConvert}
                        <ReactTooltip place="top" type="light" effect="float" />
                    </div>
                );
            }
            case 'Overdue': {
                return (
                    <div>
                        {this.getReceiveButton(cell.is_received, cell)}
                        {(cell.prevStatus === 'received' || cell.is_received) ? ( <Fragment>
                            <button data-tip="Ready" className="btn case-action-btn" onClick={(event) => this.onChangeStatus(event, cell.id, 'ready')}>
                                <span className="kr kr-ready" />
                            </button>
                            <button data-tip="Move to On hold" className="btn case-action-btn"
                                    onClick={(event) => this.onChangeStatus(event, cell.id, 'onhold')}>
                                <span className="kr kr-on-hold"/>
                            </button>
                        </Fragment> ) : (
                            <button data-tip="Delete" className="btn case-action-btn" onClick={(event) => this.onChangeStatus(event,  cell.id,'cancel')}>
                                <span className="kr kr-cancel" />
                            </button>)}
                        {actionForConvert}
                        <ReactTooltip place="top" id="convert" type="light" effect="float" />
                        <ReactTooltip place="top" type="light" effect="float" />
                    </div>
                );
            }
            default: { break; }
        }
    }

    patientFormatter(cell) {
        return <div key={cell} dangerouslySetInnerHTML={{ __html: cell }} />
    }

    dentistFormatter(cell) {
        return <div className="case-dentist" key={cell} dangerouslySetInnerHTML={{ __html: cell }} />
    }

    imagesFormatter(cell, row) {
        if (row.status !== 'Archieved') {
            return <div className="photos">
                <button onClick={(event) => this.seePhotos(event, row)}>
                    {cell ?
                        <span className="kr kr-images"/>
                        :
                        <span className="kr kr-image"/>
                    }
                </button>
                <span className="ph-num">({cell})</span>
            </div>;
        } else {
            return '';
        }
    }

    seePhotos(event, row) {
        const {currentPage, filterOptions} = this.state;
        event.stopPropagation();
        this.props.history.push({
            pathname: `/sm-admin/case-details/${row.id}`,
            state: {
                showImages: true,
                page: '/sm-admin/cases',
                pageName: 'Cases',
                filterData: filterOptions,
                pageNumber: currentPage
            }
        })
    }

    onChangeStatus(event, id, status, onhold = false, cell = {}) {
        if (onhold) {
            this.props.getAvailableUnitsList({startDate: cell.dateOfReturn});
        }
        const { currentPage, filterOptions, sortingOptions, changeStatusModal } = this.state;
        const { PATIENT: { STATUS: { REJECTED, SCHEDULED, CANCEL, RECEIVED, ON_HOLD, READY } } } = globals;
        const { changeCaseStatus } = this.props;
        // do not show during change status to onhold
        if (status === ON_HOLD) {
            this.setState({ showToaster: false });
        }
        if (onhold) {
            this.setState({
                onHoldCase: true,
                onHoldStatusData: {
                    cell,
                    id,
                    status
                }
            });
        } else if (changeStatusModal) {
            const isCurrentStatusPending = cell && cell.status === "Pending";
            const isApproved = status === SCHEDULED && isCurrentStatusPending;
            this.setState({
                caseStatus: isApproved ? 'approved' : status,
            });
            if (status === CANCEL) {
                return this.props.cancelCase(id);
            }
            changeCaseStatus({id, status}, currentPage, filterOptions, sortingOptions);
        } else {
            let modalHeaderType = 'modalHeaderSuccess';
            let defaultHeader = 'Revert from Ready';
            let defaultBody = 'Are you sure you want to revert case from Ready?';
            const targetStatus = status === 'not_received' ? SCHEDULED : status;
            if (cell.status !== 'Ready') {
                switch (status) {
                    case REJECTED:
                        modalHeaderType = 'modalHeader';
                        defaultHeader = 'Reject Case';
                        defaultBody = 'Are you sure you want to reject the case?';
                        break;
                    case SCHEDULED:
                        /* if (cell.is_received) {
                             defaultHeader = 'Mark as Not Received';
                             defaultBody = 'Are you sure you want to mark this case as Not Received?';
                         } else {
                             defaultHeader = 'Confirm Case';
                             defaultBody = 'Are you sure you want to confirm the booking request?';
                         }*/
                        defaultHeader = 'Confirm Case';
                        defaultBody = 'Are you sure you want to confirm the booking request?';
                        break;
                    case CANCEL:
                        modalHeaderType = 'modalHeader';
                        defaultHeader = 'Delete Case';
                        defaultBody = 'Are you sure you want to delete the case?';
                        break;
                    case RECEIVED:
                        defaultHeader = 'Receive Case';
                        defaultBody = 'Are you sure the case is received?';
                        break;
                    case 'not_received': {
                        defaultHeader = 'Not Received Case';
                        defaultBody = 'Are you sure you want to mark this case as Not Received?';
                        break;
                    }
                    case "onhold":
                        modalHeaderType = 'modalHeaderSuccess';
                        defaultHeader = 'On hold Case';
                        defaultBody = 'Are you sure you want to hold this case?';
                        break;
                    case READY:
                        modalHeaderType = 'modalHeaderSuccess';
                        defaultHeader = 'Ready Case';
                        defaultBody = 'Are you sure you want to change the booking status to ready?';
                        break;
                }
            }
            this.setState({
                changeStatusModal: true,
                caseId: id,
                caseStatus: targetStatus,
                modalHeaderText: defaultHeader,
                modalBodyText: defaultBody,
                modalHeaderType: modalHeaderType
            })
        }
        event.stopPropagation();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(this.state.onHoldCase && prevProps.adminAvailableUnits.availableListLoading && !this.props.adminAvailableUnits.availableListLoading ) {
            this.setState({changeHoldStatusId: this.state.onHoldStatusData.cell.id, prevHoldStatus: this.state.onHoldStatusData.cell.prevStatus});

            const isCeramicOrZirc = this.state.onHoldStatusData.cell.type === globals.CASE_TYPE.ZIRCONIA || this.state.onHoldStatusData.cell.type === globals.CASE_TYPE.CERAMIC;
            const isMiscType = this.state.onHoldStatusData.cell.type === globals.CASE_TYPE.PROTOTYPE
                || this.state.onHoldStatusData.cell.type === globals.CASE_TYPE.TEMP
                || this.state.onHoldStatusData.cell.type === globals.CASE_TYPE.OTHER;
            let zirconiaAddedUnits = 0;
            let miscAddedUnits = 0;
            const addedUnitsCase = this.props.adminAvailableUnits.data.find(item => {
                return item.dateOfReturn === this.state.onHoldStatusData.cell.dateOfReturn
            });
            if(addedUnitsCase) {
                zirconiaAddedUnits = addedUnitsCase.units_for_zirconia - addedUnitsCase.alreadyBookedZirconia;
                miscAddedUnits = addedUnitsCase.numberOfUnits - addedUnitsCase.alreadyBooked;
            }
            const availableUnitExits = miscAddedUnits ?
                ((miscAddedUnits + globals.NUMBER_OF_UNITS_MISC - this.props.adminAvailableUnits.numberOfUnits.misc) - this.state.onHoldStatusData.cell.numberOfUnits >= 0 ) :
                (globals.NUMBER_OF_UNITS_MISC - this.props.adminAvailableUnits.numberOfUnits.misc) - this.state.onHoldStatusData.cell.numberOfUnits >= 0;
            const zirconiaAvailableUnitExists = zirconiaAddedUnits ?
                ((zirconiaAddedUnits + globals.NUMBER_OF_UNITS_ZIRCONIA - this.props.adminAvailableUnits.numberOfUnits.zirconia) - this.state.onHoldStatusData.cell.numberOfUnits >= 0) :
                    (globals.NUMBER_OF_UNITS_ZIRCONIA - this.props.adminAvailableUnits.numberOfUnits.zirconia) - this.state.onHoldStatusData.cell.numberOfUnits >= 0
            if (isCeramicOrZirc && !zirconiaAvailableUnitExists){
                this.setState({
                    changeDateModal: true
                });
            } else if(isMiscType && !availableUnitExits){

                this.setState({
                    changeDateModal: true
                });
            } else {
                this.props.changeCaseStatus({id:this.state.onHoldStatusData.id, status:this.state.onHoldStatusData.status},this.state.currentPage, this.state.filterOptions, this.state.sortingOptions);

            }
        }
    }

    componentWillReceiveProps(nextProps, nextState) {
        const {currentPage, filterOptions, sortingOptions} = this.state;
        if (nextProps.adminDashboard.addIsSuccess !== this.props.adminDashboard.addIsSuccess) {
            this.setState({
                dentist: {...this.state.dentist, value: nextProps.adminDashboard.dentistInfo.id},
                dentistName: this.state.dentist ? this.state.dentist.label : '',
                addingBookingInfo: {
                    ...this.state.addingBookingInfo,
                    dentist_name: this.state.dentist.label,
                    dentistSelected: false
                }
            });
            Notice.addNotification('Dentist is successfully added.', 'success');
        } else if (nextProps.adminDashboard.addIsSuccess === false) {
            Notice.addNotification('Something went wrong.', 'error');
        }

        if (nextProps.adminDashboard.patientAdded !== this.props.adminDashboard.patientAdded) {
            this.setState({
                addingBookingInfo: {
                    ...this.state.addingBookingInfo,
                    patient_id: this.state.patient ? nextProps.adminDashboard.patientInfo.id : 0
                },
            });
            Notice.addNotification('Patient is successfully added.', 'success');
        } else if (nextProps.adminDashboard.patientAdded === false) {
            Notice.addNotification('Something went wrong.', 'error');
        }

        if (this.props.adminCaseDetails.cancelCase === null && nextProps.adminCaseDetails.cancelCase !== null) {
            let message = DELETE_CASE_SUCCESS_MESSAGE;
            let type = 'success';
            if (!nextProps.adminCaseDetails.cancelCase) {
                message = DELETE_CASE_ERROR_MESSAGE;
                type = 'error';
            }
            Notice.addNotification(message, type);
            this.setState({changeStatusModal: false, caseStatus: ''});
        }
        if (nextProps.adminCases.statusChange === true && !this.props.adminCases.statusChange) {
            this.props.getCases(currentPage, filterOptions, sortingOptions);
            if (this.state.showToaster) {
                let message = UPDATE_CASE_SUCCESS_MESSAGE;
                switch (this.state.caseStatus ) {
                    case 'rejected':
                        message = REJECT_CASE_SUCCESS_MESSAGE;
                        break;
                    case "approved":
                        message = APPROVE_CASE_SUCCESS_MESSAGE;
                }
                Notice.addNotification(message, 'success');
            } else {
                this.setState({ showToaster: true });
            }
            this.setState({changeStatusModal: false, caseStatus: ''});
        } else if (nextProps.adminCases.statusChange === false) {
            Notice.addNotification('Something went wrong.', 'error');
            this.setState({changeStatusModal: false});
        }
        if(nextProps.adminDashboard.added && this.state.addBookingShow && !this.props.adminDashboard.added){
            this.props.startImageUploading({caseId: nextProps.adminDashboard.addedData, isAdmin: true , getCase: false });
            Notice.addNotification('Successfully added.', 'success');
        }
        if (this.props.imageUpload.uploadingComplete && !this.props.imageUpload.uploadingImages && !this.props.imageUpload.hasErrors && this.state.addBookingShow) {
            if (Object.keys(nextProps.imageUpload.achievedUploads).length) {
                Notice.addNotification('Images successfully uploaded.', 'success');
            }
            this.closeAddBookingModal();
        }
        if (nextProps.adminCaseDetails.converted && !this.props.adminCaseDetails.converted) {
            Notice.addNotification(this.state.parentId ? CONVERT_TO_SUBCASE_SUCCESS_MESSAGE : CONVERT_TO_CASE_SUCCESS_MESSAGE, 'success');
            this.props.getCases(this.state.currentPage, this.state.filterOptions, this.state.sortingOptions);
            this.props.getParentCases();
            this.setState({isOpenConvertModal: false, parentId: null, isOpenProceedModal: false});
        }
        if (this.state.addingBookingInfo && this.state.addingBookingInfo.parent_id) {
            this.setState({isOpenSubcaseForm: true, createSubcaseModal: false});
        }
    }

    handleFilterDataChange(filterOptions) {
        if (!_.isEqual(filterOptions, this.state.filterOptions)) {
            this.setState({filterOptions, currentPage: 1});
        }
    }

    convertCase(id, e) {
        if (e) {
            e.stopPropagation();
        }
        if (this.state.isOpenConvertModal || this.state.isOpenProceedModal) {
            const {caseId, parentId} = this.state;
            const caseDetails = this.props.adminCases.cases.find(item => item.id === caseId);
            if (caseDetails && !caseDetails.parentId && !parentId) {
                Notice.addNotification('Please select a Case ID.', 'error');
            } else if (!this.state.isOpenProceedModal && parentId && caseDetails.patientId !== this.eventList.find(item => item.caseId === parentId).patientId) {
                this.setState({isOpenProceedModal: true, isOpenConvertModal: false})
            } else {
                const {currentPage, filterOptions} = this.state;
                this.props.convertCase(parentId ? {caseId, parentId} : {caseId}, currentPage, filterOptions);
                this.setState({isOpenConvertModal: false, isOpenProceedModal: false});
            }
        } else {
            this.setState({
                isOpenConvertModal: true,
                caseId: id
            });
        }
    }

    handleReschedule = (id) => {
        this.props.history.push(`/sm-admin/case-details/${id}`,
            {
                id: id,
                status: this.state.prevHoldStatus,
                currentPage: this.state.currentPage,
                filterOptions: this.state.filterOptions,
                sortingOptions: this.state.sortingOptions
            }
        )
    }

    handleChangeParentId = (item) => {
        this.setState({parentId: item ? item.value : item});
    };

    get eventList() {
        return this.props.adminDashboard.parentCases;
    }

    getFilteredDataRequest() {
        const currentPage = 1;
        const {filterOptions, sortingOptions} = this.state;
        this.props.getCases(currentPage, filterOptions, sortingOptions);
        this.setState({currentPage});
    }

    handleSort(column, type) {
        const sortingOptions = {sortBy: column, sortingDirection: type};
        const {filterOptions, currentPage} = this.state;
        this.props.getCases(currentPage, filterOptions, sortingOptions);
        this.setState({sortingOptions});
    }

    toggleCasesDropdown = () => {
        this.setState({ isOpenCasesDropdown: !this.state.isOpenCasesDropdown })
    }

    toggleSubcaseFormModal = (item) => {
        if (item) {
            this.props.getCaseDetails(item.caseId)
        }
        this.setState({ isOpenSubcaseForm: false, addingBookingInfo: { ...this.state.addingBookingInfo, parent_id: item && item.caseId } });
    }

    async handleSaveBooking() {
        this.props.getAllPatients();
        const bookingInfo = this.state.addingBookingInfo;
        const number_of_units = bookingInfo.number_of_units <= 0;
        const type = !(bookingInfo.type && (
            bookingInfo.type.value === 'prototype'
            || bookingInfo.type.value === 'zirconia'
            || bookingInfo.type.value === 'other'
            || bookingInfo.type.value === 'ceramic'
            || bookingInfo.type.value === 'temp'));
        const implant = !(bookingInfo.implant === '1' || bookingInfo.implant === '0');
        const patient_id =  !bookingInfo.patient_id;
        const sending_date = !bookingInfo.sending_date;
        const date_of_return = !bookingInfo.date_of_return;
        const dentist_name = !bookingInfo.dentist_name;
        const enclosedBox = !bookingInfo.enclosedBox.length;
        if (patient_id || number_of_units || type || implant || sending_date || enclosedBox || date_of_return || dentist_name) {
            this.setState({
                validationBooking: {
                    dentist_name: dentist_name,
                    date_of_return: date_of_return,
                    patient_id: patient_id,
                    sending_date: sending_date,
                    number_of_units: number_of_units,
                    type: type,
                    implant: implant,
                    enclosedBox: enclosedBox
                }
            });
        } else {
            let modalHeaderText, modalBodyText;
            if (this.state.notValidDate && !this.state.moreThenAvailableUnitsModal) {
                modalHeaderText = 'Selected Date Is Not Available';
                modalBodyText = 'There are no available units for the selected date. Do you want to book anyway?';
                this.setState({
                    moreThenAvailableUnitsModal: true,
                    openBookingFormAfterAddNewPatient: true,
                    addBookingShow: false,
                    modalBodyText,
                    modalHeaderText
                });
            } else {
                this.setState({ dataProcessing: true })
                await processImageUpdate(this.state,this.bridgesRef.current)
                const sendingData = {
                    patient_id: bookingInfo.patient_id,
                    sending_date: moment(bookingInfo.sending_date).format('YYYY-MM-DD').toString(),
                    number_of_units: bookingInfo.number_of_units,
                    type: bookingInfo.type.value,
                    notes: bookingInfo.notes,
                    admin_case_notes: bookingInfo.admin_case_notes,
                    date_of_submission: moment(this.state.dateNow).format('YYYY-MM-DD').toString(),
                    date_of_return: moment(this.state.returnDate).format('YYYY-MM-DD').toString(),
                    status: 'scheduled',
                    isAdmin: true,
                    color: bookingInfo.color,
                    signature: bookingInfo.signature,
                    license: bookingInfo.license,
                    implant: bookingInfo.implant,
                    implantType: bookingInfo.implantType,
                    implantSize: bookingInfo.implantSize,
                    enclosedBox: bookingInfo.enclosedBox,
                    implantParts: bookingInfo.implantParts,
                    image: bookingInfo.image,
                    startDate: this.state.startOfCalendarView,
                    endDate: this.state.endOfCalendarView,
                    bridges:bookingInfo.bridges
                };
                this.setState({ openBookingFormAfterAddNewPatient: false })
                this.props.addBooking(sendingData)
            }
        }
    }

    closeAddBookingModal = () => {
        this.setState({
            addBookingShow:false,
            dentistName: null,
            dentist: null,
            patient: null,
            dataProcessing: false,
            validationBooking: {
                dentist_id: false,
                patient_id: false,
                sending_date: false,
                number_of_units: false,
                type: false,
                implant: false,
                enclosedBox: false,
                dentist_name: false,
                dentistSelected: false,
                patient_name: false
            },
            addingBookingInfo: {
                parent_id: null,
                patient_id: null,
                sending_date: null,
                number_of_units: 0,
                type: '',
                notes: '',
                admin_case_notes: '',
                color: '',
                signature: '',
                license: '',
                implant: '',
                implantType: '',
                implantSize: '',
                enclosedBox: [],
                implantParts: {},
                image: [],
                bridges:[],
            },
            checkedTeeth:[],
        });
    }

    handleChangeSendingDate(sendingDate) {
        this.setState({
            addingBookingInfo: {
                ...this.state.addingBookingInfo,
                sending_date: sendingDate
            }
        });
        this.setState(prevState => ({
            validationBooking: {
                ...prevState.validationBooking,
                sending_date:  !sendingDate,
            }
        }));
    }

    handleChangeReturnDate(date) {
        this.setState({
            addingBookingInfo: {
                ...this.state.addingBookingInfo,
                date_of_return: date
            }
        });
        this.setState(prevState => ({
            validationBooking: {
                ...prevState.validationBooking,
                date_of_return:  !date,
            }
        }));
    }

    handleChangePatient(selectedOption) {
        const validationBooking = this.state.validationBooking;
        let patient_id = 0;
        if (selectedOption) {
            const match = this.patientList.find(
                entry => (entry.id === selectedOption.value));
            if (!match) {
                if (!this.state.dentist || validationBooking.dentist_name || validationBooking.dentistNotExists) {
                    validationBooking.dentistSelected = true;
                } else {
                    const data = { first_name: '', last_name: '', dentist_id: this.state.dentist.value };
                    data.first_name = selectedOption.value.split(' ').slice(0, -1).join(' ');
                    data.last_name = selectedOption.value.split(' ').slice(-1).join(' ');
                    if (!data.first_name || !data.last_name) {
                        validationBooking.patient_name = true;
                        validationBooking.dentistSelected = false;
                    }
                    else {
                        this.props.addPatient(data);
                        validationBooking.patient_id = true;
                    }
                }
            } else {
                patient_id = selectedOption.value;
            }
        }
        else {
            patient_id = 0;
        }
        this.setState(prevState => ({
            patient: selectedOption,
            validationBooking: {
                ...validationBooking,
                patient_id: !selectedOption,
            },
            addingBookingInfo: {...prevState.addingBookingInfo, patient_id,
            }
        }));
    }

    handleChangeDentist(selectedOption) {
        const validationBooking = this.state.validationBooking;
        let dentistName = '';
        if (selectedOption) {
            const match = this.props.dentistsList.find(
                entry => (entry.id === selectedOption.value));
            if (!match) {
                const data = { first_name: '', last_name: '' };
                data.first_name = selectedOption.value.split(' ').slice(0, -1).join(' ');
                data.last_name = selectedOption.value.split(' ').slice(-1).join(' ');
                if (!data.first_name || !data.last_name) {
                    validationBooking.dentist_name = true;
                    validationBooking.dentistNotExists = true;
                } else {
                    this.props.addDentist(data);
                    validationBooking.dentistSelected = false;
                    validationBooking.dentistNotExists = false
                }
            } else {
                dentistName = selectedOption.value;
            }
        } else {
            dentistName = '';
        }
        this.setState(prevState => ({
            dentist: selectedOption,
            patient: '',
            validationBooking: {
                ...validationBooking,
                dentist_name: !selectedOption,
            },
            dentistName: dentistName,
            addingBookingInfo: {...prevState.addingBookingInfo, dentist_name: dentistName,
            }
        }));
    }


    cancelBooking() {
        this.setState({cancelModal: true});
    }

    makeBridge = (from,to) => {
        const bridges = this.state.addingBookingInfo.bridges;
        const checkedTeeth = this.state.checkedTeeth;
        if(from === to) {
            if(bridges.length){
                if(checkedTeeth.includes(from) && checkedTeeth.includes(to)){
                    const filteredBridge = bridges.filter((bridge)=> {
                        return bridge.from !== from
                    })
                    const filteredTeeth = checkedTeeth.filter((teeth)=>{
                        return teeth !== from;
                    })
                    this.setState({
                        checkedTeeth:filteredTeeth,
                        addingBookingInfo:{...this.state.addingBookingInfo,bridges:filteredBridge}
                    })
                } else {
                    bridges.push({from:from, to:to})
                    checkedTeeth.push(from);
                    this.setState({
                        checkedTeeth:checkedTeeth,
                        addingBookingInfo:{...this.state.addingBookingInfo,bridges:bridges}
                    })
                }
            }else {
                checkedTeeth.push(to);
                bridges.push({from:from,to:to})
                this.setState({
                    checkedTeeth:checkedTeeth,
                    addingBookingInfo:{...this.state.addingBookingInfo,bridges:bridges}
                })
            }

        } else {
            if(checkedTeeth.includes(from) && checkedTeeth.includes(to)){
                let isBridged = false;
                const filteredBridges = bridges.filter(bridge => {
                    if (bridge.from === from && bridge.to === to) {
                        isBridged = true;
                        return false;
                    }
                    return bridge.from !== from && bridge.to !== to;
                })
                if(isBridged){
                    const filteredTeeth = checkedTeeth.filter((teeth)=>{
                        return teeth !== from && teeth !== to;
                    })
                    this.setState({
                        checkedTeeth:filteredTeeth,
                        addingBookingInfo:{
                            ...this.state.addingBookingInfo,
                            bridges: filteredBridges
                        }
                    })
                } else {
                    bridges.push({from:from,to:to});
                    this.setState({
                        addingBookingInfo:{...this.state.addingBookingInfo,bridges:bridges}
                    })
                }
            } else {
                if(from === globals.bridgesTopCenterLeft){
                    bridges.push({from:from, to:globals.bridgesTopCenterRight});
                    checkedTeeth.push(from,globals.bridgesTopCenterRight);
                    this.setState({
                        checkedTeeth:checkedTeeth,
                        addingBookingInfo:{...this.state.addingBookingInfo,bridges:bridges}
                    })
                } else if(from === globals.bridgesBottomCenterLeft){
                    bridges.push({from:from, to:globals.bridgesBottomCenterRight});
                    checkedTeeth.push(from,globals.bridgesBottomCenterRight);
                    this.setState({
                        checkedTeeth:checkedTeeth,
                        addingBookingInfo:{...this.state.addingBookingInfo,bridges:bridges}
                    })
                } else {
                    bridges.push({from: from, to: to});
                    checkedTeeth.push(from, to);
                    this.setState({
                        checkedTeeth: checkedTeeth,
                        addingBookingInfo: {...this.state.addingBookingInfo, bridges: bridges}
                    })
                }
            }
        }
    }

    render() {
        const header = 'CASES';
        const desc = 'The list of all cases';
        const potentialParents = this.eventList.filter(item => item.caseId !== this.state.caseId);

        return (
            <div className="view">
                <ViewHeader
                    header={header}
                    desc={desc}
                    primaryButtonName={'Book Case'}
                    secondaryButtonName={'Create Subcase'}
                    openModal={() => this.setState({ createSubcaseModal: true })}
                    openConvertModal={() => this.setState({ addBookingShow: true })}
                    showPrimary={true}
                    showSecondary={true}
                />
                <div className="view-content view-dashboard">
                    <div className="view-card-block">
                        {
                            (this.props.adminCases.loading) ?
                                <h1 className="text-center"><IconSpinner className="spinner"/> Loading...</h1> :
                                <Table
                                    dropDownCol={this.state.dropDownColumns}
                                    dropDown={true}
                                    dropRowId={this.state.dropRowId}
                                    isAdmin={true}
                                    totalNumber={this.props.adminCases.totalNumber}
                                    pagination={true}
                                    sortingOptions={this.state.sortingOptions}
                                    columns={this.state.tableColumns}
                                    columnShow={this.props.adminDashboard.tableConfig}
                                    data={this.props.adminCases.cases}
                                    filterOptions={this.state.filterOptions}
                                    handleFilterDataChange={this.handleFilterDataChange}
                                    handlePageChange={this.handlePageChange}
                                    currentPage={this.state.currentPage}
                                    isHeaderHidden={false}
                                    getFilteredDataRequest={this.getFilteredDataRequest}
                                    handleSort={this.handleSort}
                                    handleFilterChange={this.handleFilterChange}
                                    className="cases-mobile-table case-desktop-table"
                                />
                        }
                        {
                            this.state.changeStatusModal &&
                            <ModalComponent
                                modalHeaderStyle={this.state.modalHeaderType}
                                headerTitle={this.state.modalHeaderText}
                                modalBody={this.state.modalBodyText}
                                show={this.state.changeStatusModal}
                                handleClose={() => this.handleClose()}
                                buttonText="Yes"
                                buttonFunction={(event) => this.onChangeStatus(event, this.state.caseId, this.state.caseStatus)}
                            />
                        }
                        {
                            this.state.createSubcaseModal &&
                            <ModalComponent
                                modalHeaderStyle="modalHeaderDefault"
                                headerTitle="Create Subcase"
                                modalTitle="subcaseModalTitle modalTitle"
                                infoModal={true}
                                modalBody={<SubcaseModalBody
                                    toggleCasesDropdown={this.toggleCasesDropdown}
                                    isOpenCasesDropdown={this.state.isOpenCasesDropdown}
                                    toggleSubcaseFormModal={this.toggleSubcaseFormModal}
                                    eventList={this.eventList}
                                />}
                                dialogClassName={"subcase__modal__dialog"}
                                show={this.state.createSubcaseModal}
                                handleClose={() => this.setState({createSubcaseModal:false})}
                            />
                        }
                        {
                            this.state.isOpenSubcaseForm ?
                                <SubcaseForm
                                    caseDetails={this.props.adminCases.caseList.caseDetails && this.props.adminCases.caseList.caseDetails}
                                    parent_id={this.state.addingBookingInfo.parent_id}
                                    isAdmin={true}
                                    dashboard={this.props.adminDashboard}
                                    dashboardData={this.props.adminDashboard.data}
                                    toggleSubcaseFormModal={this.toggleSubcaseFormModal}
                                    getData={this.props.getData}
                                    isOpenSubcaseForm={this.state.isOpenSubcaseForm}
                                    addPatient={this.props.addPatient}
                                    addDentist={this.props.addDentist}
                                    addBooking={this.props.addBooking}
                                    saveDisabled={this.props.adminDashboard.addingDataLoading}
                                    minDateForSubcase={this.props.adminCaseDetails.caseList.minDateForSubcase}
                                    vacationDays={this.props.vacationDays}
                                    checkedTeeth={this.state.checkedTeeth}
                                    bridges={this.state.addingBookingInfo.bridges}
                                    makeBridge={(from,to)=>this.makeBridge(from,to)}
                                />
                                : ''
                        }
                        {
                            this.state.isHistoryModalOpen &&
                            <ModalComponent
                                modalHeaderStyle={this.state.modalHeaderType}
                                headerTitle={<span className="history__btn">Case History</span>}
                                historyModal={true}
                                modalBody={
                                    <History
                                        caseId={this.state.selectedCaseToShowHistory}
                                    />
                                }
                                show={this.state.isHistoryModalOpen}
                                handleClose={() => this.handleClose()}
                            />
                        }
                        {
                            this.state.notesByLabAdminModal &&
                            <ModalComponent
                                modalHeaderStyle="modalHeaderDefault"
                                headerTitle="Lab Admin Notes"
                                historyModal={true}
                                modalBody={<h5> {this.state.adminNote} </h5>}
                                show={this.state.notesByLabAdminModal}
                                handleClose={() => this.handleClose()}
                            />
                        }
                        {
                            this.state.addBookingShow &&
                            <ModalComponent
                                dialogClassName="book-case__dialog"
                                modalHeaderStyle="modalHeaderDefault"
                                headerTitle="Book Case"
                                modalBody={
                                    <AddBookingForm
                                        disableZirconiaType={this.state.disableZirconiaType}
                                        disableMiscType={this.state.disableMiscType}
                                        //onClickOutside={(ref) => this.clickOutside(ref)}
                                        cancelBooking={this.closeAddBookingModal}
                                        handleChange={(key, value, find = null) => this.handleChangeBookingInfo(key, value, find)}
                                        handleChangePatient={(selectedOption) => this.handleChangePatient(selectedOption)}
                                        handleChangeDentist={(selectedOption) => this.handleChangeDentist(selectedOption)}
                                        handleChangeSendingDate={(sendingDate) => this.handleChangeSendingDate(sendingDate)}
                                        handleChangeReturnDate={(date) => this.handleChangeReturnDate(date)}
                                        selectedDate={false}
                                        selectedDateKey={this.state.selectedDateKey}
                                        dateOfSubmittion={moment(this.state.dateNow).format('YYYY-MM-DD')}
                                        dentist={this.state.dentistName}
                                        dentistInfo={this.state.dentist}
                                        patientList={this.patientList}
                                        handleSaveBooking={() => this.handleSaveBooking()}
                                        validation={this.state.validationBooking}
                                        numberOfUnits={this.state.addingBookingInfo.number_of_units}
                                        numberOfUnitsForPerDay={this.state.numberOfUnitsForPerDay}
                                        implantsPart={this.state.addingBookingInfo.implantParts}
                                        enclosedBox={this.state.addingBookingInfo.enclosedBox}
                                        implantsPartObject={this.state.implantsPartObject}
                                        enclosedBoxObject={this.state.enclosedBoxObject}
                                        data={this.state.addingBookingInfo}
                                        isAdmin={true}
                                        hasErrorImages={this.state.hasErrorImages}
                                        dentistList={this.props.dentistsList}
                                        dentistsAll={this.props.dentistsList}
                                        patient={this.state.patient}
                                        removeImage={(fileName) => this.removeImage(fileName)}
                                        listNumberOfUnits={this.numberOfUnits}
                                        specialDays={this.specialDays}
                                        adminCaseNotes={this.state.patient && this.state.patient.admin_case_notes}
                                        showAdminNotesBtn={this.state.showAdminNotesBtn}
                                        date_of_return={this.state.returnDate}
                                        vacationDays={this.props.vacationDays}
                                        checkedTeeth={this.state.checkedTeeth}
                                        bridges={this.state.addingBookingInfo.bridges}
                                        makeBridge={(from,to)=>this.makeBridge(from,to)}
                                        bridgesRef={this.bridgesRef}
                                    />
                                }
                                show={this.state.addBookingShow}
                                handleClose={this.closeAddBookingModal}
                                buttonText="Save"
                                buttonFunction={() => this.handleSaveBooking()}
                                addBookingForm={true}
                                saveDisabled={this.props.adminDashboard.addingDataLoading}
                            />
                        }
                        {
                            this.state.changeDateModal &&
                            <ModalComponent
                                secondaryButton={true}
                                modalHeaderStyle="modalHeaderSuccess"
                                headerTitle={"Warning"}
                                modalBody={
                                    <div>
                                        Number of available units is expired. Are you sure you still want to add
                                        this case or you would like to reschedule?
                                    </div>
                                }
                                dialogClassName='warning-modal'
                                secondatyButtonText={'Reschedule'}
                                secondaryButtonFunction={() => this.handleReschedule(this.state.changeHoldStatusId)}
                                show={this.state.changeDateModal}
                                handleClose={this.handleClose}
                                buttonText="Change anyway"
                                buttonFunction={() => {
                                    this.props.changeCaseStatus({
                                        id: this.state.changeHoldStatusId,
                                        status: this.state.prevHoldStatus
                                    }, this.state.currentPage, this.state.filterOptions, this.state.sortingOptions)
                                    this.setState({changeDateModal: false})
                                }
                                }
                            />
                        }
                        {
                            this.state.isOpenConvertModal &&
                            <ModalComponent
                                modalHeaderStyle="modalHeaderDefault"
                                headerTitle={!this.eventList.find(item => item.caseId === this.state.caseId) ? "Convert Subcase" : "Convert Case"}
                                modalBody={!this.eventList.find(item => item.caseId === this.state.caseId) ?
                                    "Are you sure you want to convert Subcase to Case?"
                                    :
                                    <SubcaseModalBody
                                        isConvertModal={true}
                                        toggleSubcaseFormModal={this.handleChangeParentId}
                                        eventList={potentialParents}
                                        parentId={this.state.parentId}
                                    />}
                                show={this.state.isOpenConvertModal}
                                handleClose={() => this.handleClose()}
                                buttonText="Convert"
                                buttonFunction={() => this.convertCase()}
                            />
                        }
                        {
                            this.state.isOpenProceedModal &&
                            <ModalComponent
                                modalHeaderStyle="modalHeaderDefault"
                                headerTitle="Convert To Subcase"
                                modalBody={"In case you proceed the dentist and patient may be changed as well. Are you sure you want to proceed?"}
                                show={this.state.isOpenProceedModal}
                                handleClose={() => this.handleClose()}
                                buttonText="Yes"
                                isPickupModal={true}
                                buttonFunction={() => this.convertCase()}
                            />
                        }
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return ({
        vacationDays: state.adminDashboard.vacationDays,
        adminCases: state.adminCases,
        imageUpload: state.imageUploadReducer,
        adminCaseDetails: state.adminCaseDetails,
        adminDashboard: state.adminDashboard,
        adminAvailableUnits: state.adminAvailableUnits,
        dentistsList: state.adminDashboard.data.dentists,
    });
}

const mapDispatchToProps = dispatch => {
    return {
        addBooking: (data) => {
            dispatch(addBooking(data));
        },
        getData: (startOfCalendarView, endOfCalendarView) => dispatch(getData(startOfCalendarView, endOfCalendarView)),
        getCases: (page, filterOptions, sortingOptions) => dispatch(getCases(page, filterOptions, sortingOptions)),
        changeCaseStatus: (data, page, filterOptions, sortingOptions) => dispatch(changeCaseStatus(data, page, filterOptions, sortingOptions)),
        getCaseDetails: (id) => dispatch(getCase(id)),
        convertCase: (data) => dispatch(convertCase(data)),
        getParentCases: () => dispatch(getParentCases()),
        cancelCase: (data) => dispatch(cancelCase(data)),
        addPatient: (data) => {
            dispatch(addPatient(data));
        },
        addDentist: (data) => {
            dispatch(addDentist(data));
        },
        getAvailableUnitsList: (date) => {
            dispatch(getAvailableUnitsList(date));
        },
        getAllPatients: () => dispatch(getAllPatientsRequest()),
        getVacationDays: () => dispatch(getVacationDaysRequest()),
        startImageUploading: (data) => {
            dispatch(startImageUploading(data))
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(allCases);



// WEBPACK FOOTER //
// ./src/containers/Layouts/Admin/AllCases/index.js